<template>
  <div class="account">
    <div class="sec-head">
      <div>
        <span class="eyebrow">Keep it current</span>
        <h2>Account details</h2>
        <p>
          Used for your certificate, invoices and any course communication.
        </p>
      </div>
    </div>

    <div class="acard">
      <h3>Personal</h3>
      <div class="grid2">
        <div class="f">
          <label>Full name</label>
          <input v-model="form.full_name" type="text" class="form-control" />
        </div>
        <div class="f">
          <label>Email</label>
          <input v-model="form.email" type="email" class="form-control" />
        </div>
        <div class="f">
          <label>Phone</label>
          <input v-model="form.phone" type="tel" class="form-control" />
        </div>
        <div class="f">
          <label>LinkedIn URL</label>
          <input
            v-model="form.linkedin_url"
            type="url"
            placeholder="https://linkedin.com/in/…"
            class="form-control"
          />
        </div>
      </div>
    </div>

    <div class="acard">
      <h3>Password</h3>
      <div class="pw-row">
        <input type="text" value="••••••••" disabled class="form-control" />
        <router-link to="/profile" class="btn btn-outline-secondary btn-sm">
          Change password
        </router-link>
      </div>
    </div>

    <div class="acard">
      <h3>Invoice details</h3>
      <div class="f">
        <label>Organisation number</label>
        <input
          v-model="form.organisation_number"
          type="text"
          placeholder="556xxx-xxxx"
          class="form-control"
        />
      </div>
      <label class="same">
        <input v-model="same_as_above" type="checkbox" />
        Invoice address same as my address above
      </label>
      <div v-if="!same_as_above" class="f">
        <label>Invoice address</label>
        <textarea
          v-model="form.invoice_address"
          rows="3"
          class="form-control"
        />
      </div>
      <div class="save-row">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="saving"
          @click="save"
        >
          {{ saving ? 'Saving…' : 'Save changes' }}
        </button>
        <div v-if="saved" class="alert alert-success save-alert" role="alert">
          Changes saved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountForm',
  data () {
    return {
      form: {
        full_name: '',
        email: '',
        phone: '',
        linkedin_url: '',
        organisation_number: '',
        invoice_address: ''
      },
      same_as_above: true,
      saving: false,
      saved: false
    }
  },
  mounted () {
    const u = this.$store.state.user
    const p = this.$store.state.profile
    this.form.full_name =
      `${u.first_name || ''} ${u.family_name || ''}`.trim() ||
      (p.first_name || '')
    this.form.email = u.email || ''
    this.form.phone = p.phone_number || ''
    this.form.linkedin_url = p.linkedin_url || ''
    this.form.organisation_number = p.organisation_number || ''
    this.form.invoice_address = p.invoice_address || ''
  },
  methods: {
    save () {
      this.saving = true
      this.saved = false
      const payload = { ...this.form }
      if (this.same_as_above) {
        const p = this.$store.state.profile
        payload.invoice_address =
          [p.address_1, p.address_2, `${p.zip_code || ''} ${p.city || ''}`.trim()]
            .filter(Boolean)
            .join(', ')
      }
      this.$store
        .dispatch('learninghub_account_save', payload)
        .catch(() => {})
        .finally(() => {
          this.saving = false
          this.saved = true
        })
    }
  }
}
</script>

<style scoped>
.sec-head {
  margin-bottom: 18px;
}
.eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--teal-dk);
}
h2 {
  font-size: 1.55rem;
  letter-spacing: -0.01em;
  margin: 4px 0 6px;
}
.sec-head p {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: 0;
}
.acard {
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 14px;
}
.acard h3 {
  font-size: 1.05rem;
  margin: 0 0 14px;
}
.grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 700px) {
  .grid2 {
    grid-template-columns: 1fr;
  }
}
.f {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 12px;
}
.f label {
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--ink-soft);
}
.pw-row {
  display: flex;
  gap: 12px;
  align-items: center;
}
.pw-row .form-control {
  flex: 1;
}
.same {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  margin-bottom: 12px;
  cursor: pointer;
}
.save-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 6px;
}
.save-alert {
  margin: 0;
}
</style>
